/**
 * Trace Viewer - Main entry point
 *
 * For organized imports, use subpath exports:
 *   import { WrapMode, AnimationData } from 'trace-viewer/animation'
 *   import { TraceBehavior, BehaviorData } from 'trace-viewer/behaviors'
 *   import { SceneObject, SCENE_ROOT_NAME } from 'trace-viewer/scene'
 *   import { Vec3, Color } from 'trace-viewer/types'
 *
 * This main entry re-exports everything for backwards compatibility.
 */

// Register all built-in behaviors. Must be imported before any scene loading.
// Exported to create a live dependency that prevents tree-shaking of registrations.
import { registerBuiltInBehaviors } from './behaviors/registerAll';
export const BUILT_IN_BEHAVIOR_COUNT = registerBuiltInBehaviors();
// Register trace FlowGraph blocks with Babylon's KHR_interactivity pipeline.
import { registerTraceBlocks } from './behaviors/behaviorgraph/traceBlockRegistration';
registerTraceBlocks();

// Core TraceViewer
export { TraceViewer } from './core/TraceViewer';
export type { LoadResult, OpenOptions, TraceViewerElement } from './core/TraceViewer';
export type { CameraFocusOptions } from './core/Camera';

// Re-export from barrel files for backwards compatibility
export * from './exports/types';
export * from './exports/animation';
export * from './exports/behaviors';
export * from './exports/scene';

// Utility (not categorized elsewhere)
export { Utility } from './utils/Utility';
